<template>
  <!--图形验证码-->
  <div class="img-auth">
    <a href="javascript:void (0)">
      <img @click="getImgAuth" :class="classSize" :src="'data:image/png;base64,' + imgAuth.imgPath"/>
    </a>
  </div>
</template>

<script>
  import {postImgCode} from '../../assets/js/http-serve/http-methods'

  export default {
    data() {
      return {
        imgAuth: {
          imgPath: '',
          imgToken: ''
        }
      }
    },
    props: {
      verifyType: { // 废弃 图片验证码类型,可以不用
        type: Number,
        validator: function (val) {
          if(!val) return true;

          let valid = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 20, 21, 22, 99];
          if (valid.indexOf(val) === -1) {
            console.error('verifyType类型不存在')
            return false
          }
          return true
        },
        default: null
      },
      size: {
        type: String,
      },
      imgToken:[String]
    },
    mounted () {
      this.getImgAuth()
    },
    computed: {
      classSize () {
        let classStr = 'img__default'

        if (this.size === 'medium') {
          classStr = 'img__medium'
        } else if (this.size === 'small') {
          classStr = 'img__small'
        } else if (this.size === 'mini') {
          classStr = 'img__mini'
        } else if (this.size === 'column') {
          classStr = 'img__column'
        }

        return classStr
      }
    },
    methods: {
      // 获取图形验证码
      getImgAuth() {
        postImgCode(this.verifyType)
          .then(({data}) => {
            this.imgAuth = data
            this.$emit('update:imgToken', data.imgToken)
          })
          .catch(() => {
            this.$message.info('获取图形验证码失败')
          })
      }
    },
    name: "img-auth"
  }
</script>

<style lang="less" scoped>
.img-auth {
  box-sizing: border-box;
  display: inline-block;
  min-width: 100px;

  img {
    vertical-align: middle;
    width: 100%;
  }

  .img__default {
    height: 40px;
  }
  .img__medium {
    height: 36px;
  }
  .img__small {
    height: 32px;
  }
  .img__mini {
    height: 28px;
  }
  .img__column {
    height: auto;
  }

}
</style>



// WEBPACK FOOTER //
// components/img-auth/img-auth.vue